import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=8d5c3f0c&"
import script from "./shareDialog.vue?vue&type=script&lang=js&"
export * from "./shareDialog.vue?vue&type=script&lang=js&"
import style0 from "./shareDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports